/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic
 *
 * The version of the OpenAPI document: 0.1.1
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface EventdetectorId
 */
export interface EventdetectorId {
    /**
     * 
     * @type {string}
     * @memberof EventdetectorId
     */
    id?: string;
}

/**
 * Check if a given object implements the EventdetectorId interface.
 */
export function instanceOfEventdetectorId(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function EventdetectorIdFromJSON(json: any): EventdetectorId {
    return EventdetectorIdFromJSONTyped(json, false);
}

export function EventdetectorIdFromJSONTyped(json: any, ignoreDiscriminator: boolean): EventdetectorId {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': !exists(json, 'id') ? undefined : json['id'],
    };
}

export function EventdetectorIdToJSON(value?: EventdetectorId | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
    };
}

